import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/employee`;

// return axs({
//   url: `${basePath}/list`,
//   params: {
//     languageGroup: payload?.languageGroup,
//     order: payload?.order,
//     page: payload?.page,
//     keyword: payload?.keyword,
//   },
//   method: 'get',
// });

// language=&order=0&page=1&keyword=
export function fetchEmployeeList(payload: { page: number }) {
  return axs({ url: `${basePath}`, method: 'get', params: payload });
}
export function fetchEmployeeListAll() {
  return axs({ url: `${basePath}`, method: 'get' });
}
export function fetchManagerList() {
  return axs({ url: `${basePath}/project`, method: 'get' });
}

export function registerEmployee(payload: {
  email: string;
  authority: number;
  name: string;
  postPosition: string;
  assignedTask: string;
  phone: string;
  phonecode: number;
}) {
  return axs({ url: `${basePath}`, method: 'post', data: payload });
}

export function updateEmployee(payload: {
  email: string;
  authority: number;
  name: string;
  postPosition: string;
  assignedTask: string;
  phone: string;
  phonecode: number;
  employeeIdx: number;
}) {
  return axs({ url: `${basePath}`, method: 'put', data: payload });
}

export function deleteEmployee(payload: { employeeIdx: number }) {
  return axs({ url: `${basePath}`, method: 'delete', data: payload });
}

export function fetchProjectGraph() {
  return axs({ url: `${basePath}/projectgraph`, method: 'get' });
}

export function signInByEmployee(payload: {
  nickname: string;
  email: string;
  password: string;
  autoLogin?: number;
}) {
  return axs({
    url: `${basePath}/login`,
    method: 'post',
    data: {
      autoLogin: 0,
      ...payload,
    },
  });
}

export function sendEmailForReset(payload: { email: string; nickname: string }) {
  return axs({
    url: `${basePath}/password/reset/email`,
    method: 'post',
    data: payload,
  });
}

// return "userInfo": { "email": "tester@dof.com", "groupCode": "21OCT20-001", "nickname": "nickname_sender_12323" }
export function fetchEmployeeBykey(payload: { resetKey: string }) {
  return axs({ url: `${basePath}/temp/login`, method: 'post', data: payload });
}

export function editEmployeePassword(payload: {
  resetKey: string;
  groupCode: string;
  email: string;
  newPassword: string;
}) {
  return axs({ url: `${basePath}/password`, method: 'put', data: payload });
}
